var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.534,
    height: 71.534,
    viewBox: "0 0 71.534 71.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1719",
    "data-name": "Trazado 1719",
    d: "M37.767,73.534A35.767,35.767,0,1,0,2,37.767,35.767,35.767,0,0,0,37.767,73.534ZM48.5,30.614a10.73,10.73,0,1,1-10.73-10.73A10.73,10.73,0,0,1,48.5,30.614ZM16.3,55.651a26.829,26.829,0,0,1,42.925,0,26.829,26.829,0,0,1-42.925,0Z",
    transform: "translate(-2 -2)",
    fill: "#fab2c2",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.9c600eee9191c338202b205abcfac39f.svg";
export { ForwardRef as ReactComponent };